import Loader from '../../components/loader.jsx';
import events from 'lib/events';
import React from 'react';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

import {getCurrentScanner, getAccuscanStrip, getAccuscanStrips, getInitialAccuscanStrips, nextAccuscanStrip, getScanURL} from 'services/testConnect';

class ScanProgress extends React.Component {
  static displayName = 'ScanProgress';

  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    show: false,
    url: null,
    progress: 0,
    resetting: false,

    scanner: null,
    currentStrip: null,
    numCurrentStrip: null,
    numTotalStrip: null,
  };

  componentDidMount() {
    this.mounted = true;

    events.subscribe('scannerProgress.clickable', () => {
      this.setState({
        clickable: true,
      });
    });
    events.subscribe('scannerProgress.noClickable', () => {
      this.setState({
        clickable: false,
      });
    });
    events.subscribe('scanner.start', () => {
      this.setState({
        progress: 0,
        show: true,
        url: getScanURL(),
        scanner: getCurrentScanner(),
        testStripName: getAccuscanStrip(),
        numCurrentStrip: getInitialAccuscanStrips() - getAccuscanStrips().length + 1,
        numTotalStrip: getInitialAccuscanStrips(),
      });
    });
    events.subscribe('scanner.progress', p => {
      this.setState({
        progress: parseInt(p),
      });
    });
    events.subscribe('scanner.resetting', () => {
      this.setState({resetting: true});
      setTimeout(() => {
        if (this.state.numCurrentStrip < this.state.numTotalStrip) {
          nextAccuscanStrip();
          setTimeout(() => {
            this.setState({resetting: false});
          }, 3000);
        } else {
          this.setState({resetting: false});
        }
      }, 15000);
    });
    events.subscribe('scanner.complete', () => {
      if (this.state.scanner === 'Accuscan' && getInitialAccuscanStrips() === 0) {// Test Connect service clears internal state, but want to show all tests done
        this.setState({
          progress: 100,
          numCurrentStrip: this.state.numTotalStrip,
        });
      } else {
        this.setState({
          progress: 100,
          testStripName: getAccuscanStrip(),
          numCurrentStrip: getInitialAccuscanStrips() - getAccuscanStrips().length + 1,
          numTotalStrip: getInitialAccuscanStrips(),
        });
      }
    });
    events.subscribe('scanner.cancel', () => {
      this.setState({
        show: false,
        url: null,
        scanner: null,
        testStripName: null,
        numCurrentStrip: null,
        numTotalStrip: null,
      });
    });

    events.subscribe('scanner.customer', data => {
      if (this.mounted && this.state.progress === 100 && !this.state.resetting && this.state.url) {
        let splitURL = this.state.url.split('/');

        if (splitURL.includes(data.customerID)) {
          return;
        }

        this.cancel();
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  cancel = () => {
    events.publish('scanner.cancel');
    this.setState({
      url: null,
      progress: 0,
      resetting: false,
      show: false,
      scanner: null,
      currentStrip: null,
      numCurrentStrip: null,
      numTotalStrip: null,
    });
  };

  progressSection = () => {
    const {formatMessage} = this.props.intl;

    if (this.state.scanner === 'SmartLab') {
      let progressContainerStyles = {
        backgroundColor: '#fff',
        border: 'solid 2px #0093d6',
        borderRadius: '20px',
        height: '24px',
        padding: '2px',
        position: 'relative',
        overflow: 'visible',
      };
      let progressBarStyles = {
        backgroundColor: '#0093d6',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: 600,
        width: this.state.progress + '%',
      };
      let progressBarCheckStyles = {
        backgroundColor: '#061f5c',
        border: 'solid 2px #fff',
        borderRadius: '15px',
        color: '#fff',
        fontSize: '11px',
        height: '30px',
        lineHeight: '30px',
        padding: '0px 5px',
        position: 'absolute',
        right: '-5px',
        top: '-5px',
        width: '30px',
      };

      let progressBarContent = '';
      let progressBarCheck = null;

      if (this.state.progress !== 0) {
        progressBarContent = this.state.progress + '%';
      }
      if (this.state.progress === 100) {
        progressBarContent = formatMessage({id: 'scanning.progress-bar.complete'});
        progressBarCheck =
          <div style={progressBarCheckStyles}>
            <i className='bl bl-checkmark'/>
          </div>
        ;
      }

      return <div className='col-md-offset-5 col-md-3'
                  style={{paddingLeft: '30px'}}>
        <div className='progress'
             style={progressContainerStyles}>
          {progressBarCheck}
          <div className='progress-bar'
               role='progressbar'
               aria-valuenow={this.state.progress}
               aria-valuemin='0'
               aria-valuemax='100'
               style={progressBarStyles}>
            {progressBarContent}
          </div>
        </div>
      </div>;
    }

    if (this.state.scanner === 'Accuscan') {
      if (this.state.resetting) {
        return <div className='col-md-8'
                    style={{paddingRight: '58px'}}>
          <p style={{textAlign: 'right'}}>
            <span className='b'><FormattedMessage id='analysis.resseting.scanner'/>... </span>
          </p>
          <Loader options={{
            color: '#0093d6',
            lines: 8,
            top: '40%',
            left: '96%',
            length: 0,
          }}/>
        </div>;
      }

      if (this.state.progress === 100 && this.state.numCurrentStrip === this.state.numTotalStrip) {
        return <div className='col-md-8'
                    style={{textAlign: 'right'}}>
          <FormattedMessage id='scanning.accuscan.strips.complete'
                            values={{
                              n: this.state.numCurrentStrip,
                              total: this.state.numTotalStrip,
                              checkmark: <i className='bl bl-check blue'/>,
                            }}/>
        </div>;
      }

      if (this.state.progress === 100) {
        return <div className='col-md-8'>
          <p style={{textAlign: 'right'}}>
            <i className='bl bl-attention fa-lg red'/>
            <span className='b'> {this.state.testStripName} </span>
            <span className='dim n'>({this.state.numCurrentStrip} of {this.state.numTotalStrip}) </span>
            - <FormattedMessage id='analysis.load.test.strip'/>
          </p>
        </div>;
      }

      return <div className='col-md-8'
                  style={{paddingRight: '58px'}}>
        <p style={{float: 'left'}}><FormattedMessage id='analysis.load.test.strip'/></p>
        <p style={{textAlign: 'right'}}>
          <span className='b'>{this.state.testStripName} </span>
          <span className='dim n'>({this.state.numCurrentStrip} of {this.state.numTotalStrip}) </span>
        </p>
        <Loader options={{
          color: '#0093d6',
          lines: 8,
          top: '40%',
          left: '96%',
          length: 0,
        }}/>
      </div>;
    }

    return null;
  };

  render() {
    if (!this.state.show) {
      return null;
    }

    let title = 'analysis.in.progress';

    if (this.state.progress === 100) {
      title = 'analysis.scan.complete';
    }

    return <div className='progress-header-container'>
      <div className="spacer"/>

      <div className="header-wrap">
        <div className='container'>
          <div className='row'>
            <div className='col-md-4'>
              <p className='b'>
                <i className='blue bl bl-water-test water-test-icon'/>
                <a tabIndex={this.state.clickable ? '0' : '-1'}
                   className={this.state.clickable ? 'clickable-link' : 'no-clickable-link'}
                   href={this.state.url}><FormattedMessage id={title}/>
                </a> &gt;
                {
                  this.state.progress === 100 && !this.state.resetting ?
                    <button className='btn btn-default cancel-button'
                            onClick={this.cancel}><FormattedMessage id='general.cancel'/></button> :
                    null
                }
              </p>
            </div>
            {this.progressSection()}
          </div>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(ScanProgress);
